type ParamValue = string | null | { code: string } | Array<string | { code: string }>;

type Params = Record<string, ParamValue>;

export function paramsToUrlData(params: Params): string {
  let urlData = '';

  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === '') {
      return;
    }

    if (Array.isArray(value) && value.length <= 0) {
      return;
    }

    let preparedValue: string;

    if (Array.isArray(value)) {
      preparedValue = value
        .map((element) => (typeof element === 'object' && element !== null ? element.code : element))
        .join(',');
    } else if (typeof value === 'object') {
      preparedValue = value.code;
    } else {
      preparedValue = value;
    }

    urlData += `${key}/${preparedValue}/`;
  });

  return urlData;
}

export type UrlParams = {
  data?: string[];
};

export function getParamValue(params: UrlParams, paramName: string): string | null {
  const index = params?.data?.findIndex((param) => param === paramName);
  if (index === null || index === undefined || index === -1) return null;
  if (!params?.data || !((index + 1) in params.data)) return null;

  return decodeURIComponent(params.data[index + 1]);
}

